/*jshint esversion: 6 */
import Ajax from '../common/Ajax';
import * as Utils from '../common/Utils';

export default (function(config){

    config.selector = (typeof  config.selector !== 'undefined') ?   config.selector : 4;

    if(config.selector === ''){
        console.log('REQUIRED Element ID');
        return;
    }


    let elements = document.getElementsByClassName(config.selector);


    var isTypeValid = function(type){
        let isTypeValid = false;
        if(type === 'video' || type === 'article' || type === 'elearning-module' || type === 'elearning-course'){
              isTypeValid = true;
        }
        return isTypeValid;
    };

    let success = function(response){
        if (response.message === 'item_already_saved') {
            Utils.displayAlert(translations.item_already_saved, 'success');
        } else if (response.message === 'item_saved') {
            Utils.displayAlert(translations.item_saved, 'success');
        } else {
            Utils.displayAlert(response.message, 'success');
        }
    };

    let error = function(response){
        Utils.displayAlert(response, 'error');
    };


    var attachLinks = function(elements){

        for(var i= 0; i < elements.length; i++){
            attachLink(elements[i]);
        }
    };


    var attachLink = function(element) {
        element.onclick = function(event){
            event.preventDefault();
            Utils.removeAlert();
            let type = this.getAttribute('data-content-type');
            let id = this.getAttribute('data-id');

            if(!isTypeValid(type)){
                console.log('Content type is not valid');
                return;
            }

            var route = Utils.generateRouteFromPattern({
                pattern : {
                    '%type%' : type,
                    '%id%': id
                },
                route : config.route,
                env : config.env,
                locale: config.locale
            });

            Ajax.postRequest(route, {}, success, error);

            return false;
        }
    }

    attachLinks(elements);

});


